module.exports = __webpack_public_path__ + "static/media/StudentSignUp.85bad610.mp4";